import {
    GridColumnMenuContainer,
    GridColumnMenuHideItem,
    GridColumnMenuPinningItem,
    GridColumnMenuColumnsItem, // <--- Importa el administrador de columnas
    GridColumnMenuProps,
} from '@mui/x-data-grid-pro';

export function MyColumnMenu(props: GridColumnMenuProps) {
    const { hideMenu, colDef, ...other } = props;
    
    return (
        <GridColumnMenuContainer hideMenu={hideMenu} colDef={colDef} {...other}>
            
            {/* Agrega “pin” si lo necesitas */}
            <GridColumnMenuPinningItem onClick={hideMenu} colDef={colDef} />
            
            {/* Hide column */}
            {/* <GridColumnMenuHideItem onClick={hideMenu} colDef={colDef} /> */}
            
            {/* Column manager */}
            {/* <GridColumnMenuColumnsItem onClick={hideMenu} colDef={colDef} /> */}
            
            {/* No ponemos más items */}
        </GridColumnMenuContainer>
    );
}
